export class DsPinComment {
  /**
   *
   */
  public id: number | null = null;

  /**
   *
   */
  public date: number | null;

  /**
   *
   */
  public accountID: number | null;

  /**
   *
   */
  public content: string | null;

  /**
   *
   */
  public photo: string | null;

  /**
   * Creates an instance of DsPinComment.
   *
   * @param jsonData the json data
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(jsonData: any = {}) {
    this.id = jsonData.id || this.id;
    this.date = jsonData.date || this.date;
    this.accountID = jsonData.accountID || this.accountID;
    this.content = jsonData.content || jsonData.content === '' ? jsonData.content : this.content;
    this.photo = jsonData.photo || jsonData.photo === '' ? jsonData.photo : this.photo;
  }
}
